import { GetTodaysDateINdmy } from "../../../CommonFunction/GetTodaysDate";

export let IDFCConfig = {
  IDFCHeaders: [
    "Beneficiary Name",
    "Beneficiary Account Number",
    "Beneficiary IFSC Code",
    "Transaction Type",
    "Debit Account Number",
    "Transaction Date",
    "Amount",
    "Currency",
    "Beneficiary Email ID",
    "Remarks",
  ],

  IDFCFields: {
    Party_Name: "",
    Account_Number: "",
    Bank_IFSC_Code: "",
    TypeOfPayment: "",
    Debit_Account_Number: "",
    Transaction_Date: GetTodaysDateINdmy(),
    Amount: 0,
    Currency: "INR",
    Beneficiary_Email_ID: "",
    Remarks: "",
  },
};

export let KOTAKConfig = {
  Client_Code: "ORIONEXP",
  Product_Code: "RPAY",
  TypeOfPayment: "",
  Payment_ReAf_No: "",
  Transaction_Date: GetTodaysDateINdmy(),
  Instrument_Date: "",
  Debit_Account_Number: "",
  Amount: 0,
  Bank_Code_Indicator: "M",
  Beneficiary_Code: "",
  Party_Name: "",
  Bank_Name: "",
  Bank_IFSC_Code: "",
  Account_Number: "",
  Location: "",
  Print_Location: "",
  Instrument_Number: "",
  Ben_Add1: "",
  Ben_Add2: "",
  Ben_Add3: "",
  Ben_Add4: "",
  Beneficiary_Email_ID: "",
  Beneficiary_Mobile: "",
  Debit_Narration: "",
  Credit_Narration: "",
  Payment_Details_1: "",
  Payment_Details_2: "",
  Payment_Details_3: "",
  Payment_Details_4: "",
  Enrichment_1: "",
  Enrichment_2: "",
  Enrichment_3: "",
  Enrichment_4: "",
  Enrichment_5: "",
  Enrichment_6: "",
  Enrichment_7: "",
  Enrichment_8: "",
  Enrichment_9: "",
  Enrichment_10: "",
  Enrichment_11: "",
  Enrichment_12: "",
  Enrichment_13: "",
  Enrichment_14: "",
  Enrichment_15: "",
  Enrichment_16: "",
  Enrichment_17: "",
  Enrichment_18: "",
  Enrichment_19: "",
  Enrichment_20: "",
};
